import { Alert, Button, Card } from "flowbite-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { isValidCNPJ, isValidCPF } from "../../utils/utils";
import axios from "../../config/axiosInstance";
import { ADMIN, QUERIES } from "../../config/apiConfig";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import usePDF from "../../hooks/usePDF";
import CardQueryDescription from "../common/CardQueryDescription";
import SliderToPreview from "../common/SliderToPreview";
import QueryLoading from "../common/QueryLoading";
import QueryInput from "../inputs/QueryInput";
import { useQuery } from "react-query";
import DrawerLoading from "../DrawerLoading";
import LocalizacaoPFQuery from "./custom-queries-credit/LocalizacaoPFQuery";
import LocalizacaoPJQuery from "./custom-queries-credit/LocalizacaoPJQuery";
import TitleStripe from "../common/TitleStripe";
import ScrBacenQuery from "./custom-queries-credit/ScrBacenQuery";
import { useReactToPrint } from "react-to-print";
import { FaPrint } from "react-icons/fa6";
import AvisoCard from "../common/query/AvisoCard";
import moment from "moment";
import CadastralPFQuery from "./custom-queries-cadastral/CadastralPFQuery";
import CadastralPJQuery from "./custom-queries-cadastral/CadastralPJQuery";
import PreparePrint from "../common/PreparePrint";
import FooterLGPD from "../common/query/FooterLGPD";
import ErrorQuery from "../common/query/ErrorQuery";
import ParticipacaoEmEmpresas from "../common/query/ParticipacaoEmEmpresas";
import ParticipacaoEmEmpresasQuery from "./custom-queries-cadastral/ParticipacaoEmEmpresasQuery";
import CadastralPremiumPFQuery from "./custom-queries-cadastral/CadastralPremiumPFQuery";
import CadastralPremiumPJQuery from "./custom-queries-cadastral/CadastralPremiumPJQuery";

const CustomCadastralQueryReview = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
  hasHeaderPDF = true,
  isReviewOpen = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [isDoneRequest, setIsDoneRequest] = useState(false);
  const [error, setError] = useState("");
  const [errorQuery, setErrorQuery] = useState(0);
  const [document, setDocument] = useState("");
  const [isPrinting, setIsPrinting] = useState(false);
  const [queryName, setQueryName] = useState("");
  const componentRef = useRef();
  const printRef = useRef();
  const handleAfterPrint = useCallback(() => {
    setIsPrinting(false);
  }, []);

  const handleBeforePrint = useCallback(() => {
    setIsPrinting(true);
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `consulta_${document}`,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  const {
    isLoading: isLoadingQueryReview,
    error: errorQueryReview,
    data: data,
  } = useQuery(
    ["data", query?.id],
    async () => {
      const { data } = await axios.get(
        `${!isReviewOpen ? QUERIES.GET_USER_QUERY : QUERIES.REVIEW_QUERY}/${
          query?.id
        }`
      );

      setDocument(data.data.parameter);
      setQueryName(data?.data?.q?.name);

      return data?.data?.data;
    },
    {
      enabled: !!query,
    }
  );

  const renderComponentByKey = (key, dataItem, document) => {
    switch (key) {
      case "cadastralPF":
        return <CadastralPFQuery data={dataItem} />;
      case "cadastralPremiumPF":
        return <CadastralPremiumPFQuery data={dataItem} />;
      case "cadastralPremiumPJ":
        return <CadastralPremiumPJQuery data={dataItem} />;
      case "cadastralPJ":
        return <CadastralPJQuery data={dataItem} />;
      case "participacaoEmEmpresas":
        return <ParticipacaoEmEmpresasQuery data={dataItem} />;
      default:
        return null;
    }
  };

  const renderSortedData = () => {
    const itemsArray = Object.entries(data)
      .filter(([key, value]) => value && value.prioridade)
      .sort(([, aValue], [, bValue]) => aValue.prioridade - bValue.prioridade);

    return itemsArray.map(([key, dataItem]) => (
      <React.Fragment key={key}>
        {renderComponentByKey(key, dataItem, document)}
      </React.Fragment>
    ));
  };

  return (
    <>
      <PreparePrint isPrinting={isPrinting} />

      <>
        <div
          className={`overflow-x-scroll print-content mobile-fit ${
            data || isLoading ? "block" : "hidden"
          }`}
          ref={(el) => {
            componentRef.current = el;
            printRef.current = el;
          }}
        >
          {!isLoading && data ? (
            <>
              <Card className="card-pdf p-5 relative overflow-hidden">
                <HeaderQuery hasHeader={hasHeaderPDF} title={queryName} />

                {renderSortedData()}

                <FooterLGPD />
              </Card>
            </>
          ) : (
            <QueryLoading />
          )}
        </div>
      </>
    </>
  );
};

export default CustomCadastralQueryReview;
